
import { Structure } from "addiction-components";
import { UnknownObject } from "../unknown-object.interface";

export interface StructureUser extends Structure {
	[key: string]: unknown | UnknownObject;
}
